import useMakeApiRequest from './makeApiRequest';

const getRecaptcha = () => {
	const makeApiRequest = useMakeApiRequest('GET');

	const getCaptcha = async (token: any, apiBase: string, checkbox: boolean) => makeApiRequest(`${apiBase}/api/recaptcha-enterprise/verify?token=${token}&checkbox=${checkbox}`, {});

	return [getCaptcha];
};

export default getRecaptcha;
